import React, { useEffect, useRef } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Image from 'components/Image';
import * as EventUtils from 'utils/eventUtils';

const ImageCarouselInner = ({
    data,
    activeIndex,
    imageStyle,
    handleChange,
    slide = true,
    fade = false,
    controls = data.length > 1,
    indicators = data.length > 1,
    interval = 3000,
    pause = 'hover',
    wrap = true,
    touch = true,
    forwardedRef,
    ...rest
}) => {
    const ref = useRef();

    useEffect(() => {
        if (ref.current && forwardedRef) {
            forwardedRef.current = ref.current.element;
        }
    }, [forwardedRef]);

    const onItemSelect = (selectedIndex, e) => {
        EventUtils.stopPropagation(e);
        handleChange(selectedIndex);
    };

    return (
        <Carousel
            slide={slide}
            fade={fade}
            controls={controls}
            indicators={indicators}
            interval={interval}
            pause={pause}
            wrap={wrap}
            touch={touch}
            activeIndex={activeIndex}
            onSelect={onItemSelect}
            ref={ref}
            {...rest}
        >
            {data.map((x, index) => (
                <Carousel.Item key={index}>
                    <Image className="w-100 h-100" style={imageStyle} imageSrc={x} />
                </Carousel.Item>
            ))}
        </Carousel>
    );
};

const ImageCarousel = React.forwardRef((props, ref) => <ImageCarouselInner {...props} forwardedRef={ref} />);

export default ImageCarousel;
